// Reusable <th> for tables backed by useSortableData.
// Click toggles asc -> desc -> none. Shows ↑/↓ when active.
function SortableHeader({ sortKey, currentKey, direction, onSort, className = "", children, align = "left" }) {
  const isActive = currentKey === sortKey;
  const indicator = isActive ? (direction === "asc" ? "↑" : "↓") : "";
  const justify = align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start";
  return (
    <th
      onClick={() => onSort(sortKey)}
      className={`cursor-pointer select-none hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${className}`}
    >
      <span className={`inline-flex items-center gap-1 w-full ${justify}`}>
        {children}
        <span className={`text-xs ${isActive ? "opacity-100" : "opacity-30"}`}>
          {indicator || "↕"}
        </span>
      </span>
    </th>
  );
}

export default SortableHeader;
